module.exports = __webpack_public_path__ + "media/images/city/036-zakim-bridge-150d864b2286e181fcea3da13f33ba98.svg";